<template>
  <div class="wrapper">
    <div class="contentBox">
      <div class="searchBar">
        <el-form :inline="true">
          <el-form-item label="论文名称:">
            <el-input
              class="searchInput"
              size="small"
              placeholder="论文名称"
              v-model="searchCondition.paperName"
              clearable
            >
            </el-input>
          </el-form-item>
          <el-form-item label="考生姓名:"
            ><el-input
              class="searchInput"
              size="small"
              placeholder="考生姓名"
              v-model="searchCondition.userName"
              clearable
            >
            </el-input
          ></el-form-item>
          <el-form-item label="手机号:"
            ><el-input
              class="searchInput"
              size="small"
              placeholder="手机号"
              v-model="searchCondition.mobile"
              clearable
            >
            </el-input
          ></el-form-item>
          <el-form-item label="身份证:"
            ><el-input
              class="searchInput"
              size="small"
              placeholder="身份证"
              v-model="searchCondition.idCard"
              clearable
            >
            </el-input
          ></el-form-item>
          <el-form-item label="科目:"
            ><el-select
              v-model="searchCondition.testId"
              size="small"
              placeholder="科目"
            >
              <el-option
                value=""
                label="所有科目"
                key="'testSeachNone'"
              ></el-option>
              <el-option
                v-for="item in testList"
                :value="item.id"
                :label="item.testName"
                :key="'testSeach' + item.id"
              ></el-option> </el-select
          ></el-form-item>
          <el-form-item label="审核状态:">
            <el-select
              style="width: 120px"
              v-model="searchCondition.reviewStatus"
              placeholder="审核状态"
              size="small"
            >
              <el-option
                v-for="item in reviewOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option> </el-select
          ></el-form-item>
          <el-form-item label="分配状态:">
            <el-select
              style="width: 180px"
              v-model="searchCondition.distributeStatus"
              placeholder="请选择论文分配状态"
              size="small"
            >
              <el-option label="所有分配状态" value=""> </el-option>
              <el-option label="未分配" :value="2"> </el-option>
              <el-option label="已分配" :value="1"> </el-option> </el-select
          ></el-form-item>
          <el-form-item label="提交时间:"
            ><el-date-picker
              size="small"
              v-model="searchCondition.searchRangeTime"
              @change="timeRangeChange"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker
          ></el-form-item>
          <el-form-item label="审核人:"
            ><el-input
              class="searchInput"
              size="small"
              placeholder="审核人"
              v-model="searchCondition.auditTeacher"
              clearable
              style="width: 200px"
            >
            </el-input
          ></el-form-item>
        </el-form>

        <el-button
          type="primary"
          size="small"
          icon="el-icon-search"
          style="margin-top: 10px"
          @click="getPaperReviewList"
          >查询
        </el-button>
        <el-button
          type="info"
          size="small"
          style="margin-top: 10px"
          icon="el-icon-refresh-right"
          @click="resetSearchCondition"
          >重置
        </el-button>
      </div>

      <div class="tableContainer">
        <div class="actionBar">
          <el-button plain @click="exportData" size="small"> 导出 </el-button
          >&emsp;

          <el-dropdown trigger="click" class="reviewBar">
            <el-button type="primary" size="small">导出开题报告</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button
                  type="primary"
                  @click="downloadReport(false)"
                  size="mini"
                  :disabled="selectIds.length == 0"
                  >导出当前页勾选</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="primary"
                  @click="downloadReport(true)"
                  size="mini"
                  >导出此筛选所有记录</el-button
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          &emsp;
          <el-button
            plain
            @click="dialogVisible = true"
            accept=".xls,.xlsx"
            size="small"
          >
            导入 </el-button
          >&emsp;

          <!-- <el-button
            class="reviewBar"
            type="primary"
            size="small"
            @click="reviewBatchPaper(0)"
            >审核不通过
          </el-button> -->
          <!-- <el-button
            class="reviewBar"
            type="primary"
            size="small"
            @click="reviewBatchPaper(1)"
            >审核通过
          </el-button> -->
          <el-button
            type="primary"
            size="small"
            @click="
              Object.assign(auditSettingData, $options.data().auditSettingData);
              auditSettingData.ifShow = true;
            "
          >
            评审设置
          </el-button>
          <!-- <el-dropdown trigger="click" class="reviewBar">
            <el-button type="primary" size="small">一键下载论文</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button
                  @click="batchDownloadThesis(false)"
                  type="primary"
                  size="mini"
                  :disabled="selectIds.length == 0"
                  >下载当前页勾选</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  @click="batchDownloadThesis(true)"
                  type="primary"
                  size="mini"
                  :disabled="!searchCondition.testId"
                  >下载此筛选所有记录</el-button
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          <!-- <el-button
            type="primary"
            size="small"
            @click="allocateThesis"
            :disabled="selectIds.length == 0"
            >一键分配</el-button
          > -->
          <el-dropdown
            trigger="click"
            class="reviewBar"
            v-if="roleCode != 'bus'"
          >
            <el-button type="primary" size="small">一键分配</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button
                  @click="allocateThesis(false)"
                  type="primary"
                  size="mini"
                  >分配当前页勾选</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  @click="allocateThesis(true)"
                  type="primary"
                  size="mini"
                  >分配此筛选所有记录</el-button
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-dropdown
            trigger="click"
            class="reviewBar"
            v-if="roleCode != 'bus'"
          >
            <el-button type="primary" size="small">一键分配</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button
                  @click="oneClickSplit(false)"
                  type="primary"
                  size="mini"
                  :disabled="selectIds.length == 0"
                  >分配当前页勾选</el-button
                >
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  @click="oneClickSplit(true)"
                  type="primary"
                  size="mini"
                  :disabled="!searchCondition.testId"
                  >分配此筛选所有记录</el-button
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
          &ensp;
          <el-dropdown
            trigger="click"
            class="reviewBar"
            v-if="roleCode != 'bus'"
          >
            <el-button type="primary" size="small">一键发布</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button
                  type="primary"
                  size="mini"
                  :disabled="selectIds.length == 0"
                  @click="oneClickRelease(false)"
                >
                  发布当前页勾选
                </el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-button
                  type="primary"
                  size="mini"
                  @click="oneClickRelease(true)"
                  :disabled="!searchCondition.testId"
                  >发布此筛选所有记录</el-button
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <Table
          :columns="columns"
          :data="paperReviewList"
          border
          @on-selection-change="choosenChange"
        >
          <template slot-scope="{ row, index }" slot="action">
            <div>
              <el-button plain size="mini" class="bluBar" @click="pdfShow(row)"
                >预览
              </el-button>
              <el-button
                size="mini"
                class="bluBar"
                @click="goToDetail('thesisAudit', row, 1)"
                >审核
              </el-button>
              <el-button
                size="mini"
                class="bluBar"
                @click="download(row.paperUrl)"
                >下载
              </el-button>
            </div>
          </template>
        </Table>

        <el-dialog
          title="提示"
          :visible.sync="dialogVisible"
          width="40%"
          append-to-body
          @closed="reset()"
        >
          <el-form>
            <el-form-item label="模板说明">
              <el-tag type="info"
                >excel模版说明:批量更新审核状态，需按照此模板填写，不要改变原始样式</el-tag
              >
            </el-form-item>
            <el-form-item label="模板下载">
              <el-tag>
                <i class="el-icon-download" />
                <!-- 这里的话可以把这个模板放到阿里的OSS中 这个地方是采用放入项目中-->
                <a :href="downloadUrl" icon="md-album">点击下载模板</a>
              </el-tag>
            </el-form-item>
            <el-form-item label="上传文件">
              <el-upload
                ref="upload"
                :auto-upload="false"
                :on-change="fileChange"
                :on-exceed="exceedFile"
                :on-success="handleSuccess"
                :on-error="handleError"
                :http-request="uploadPaper"
                :limit="1"
                :headers="{
                  Authorization: getStore('accessToken'),
                  accountId: 1,
                }"
                action="/bpi/paper-setting/v1/excel/excelImport"
                name="file"
                accept=".xls,.xlsx"
                :file-list="fileList"
              >
                <el-button size="small" plain>选择文件</el-button>
                &emsp;!只能上传xls/xlsx文件
              </el-upload>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="importData()">确 定</el-button>
          </span>
        </el-dialog>

        <!--分页-->

        <el-row>
          <el-col :span="24">
            <div class="pagination">
              <el-pagination
                @size-change="getPaperReviewList"
                @current-change="getPaperReviewList"
                :current-page.sync="searchCondition.jumpPage"
                :page-sizes="[10, 30, 100]"
                :page-size.sync="searchCondition.pageSize"
                layout="total,sizes, prev, pager, next,jumper"
                :total="searchCondition.total"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog
      title="论文预览"
      :visible.sync="pdfData.pdfIfShow"
      width="70%"
      :append-to-body="true"
      top="2vh"
    >
      <pdf-preview :url="pdfData.pdfUrl" v-if="pdfData.pdfIfShow"></pdf-preview>
    </el-dialog>
    <el-dialog
      title="评审设置"
      :visible.sync="auditSettingData.ifShow"
      width="700px"
      :append-to-body="true"
    >
      <el-form label-width="200px">
        <el-form-item label="科目">
          <el-select
            v-model="auditSettingData.examinationId"
            size="small"
            placeholder="请选择科目"
            @change="getReviewSettings"
          >
            <el-option
              v-for="item in testList"
              :value="item.id"
              :label="item.testName"
              :key="'auditSettingData' + item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否可以被多名专家审核">
          <el-radio
            :disabled="auditSettingData.id || auditSettingData.id == 0"
            v-model="auditSettingData.isMultiple"
            :label="1"
            >是</el-radio
          >
          <el-radio
            :disabled="auditSettingData.id || auditSettingData.id == 0"
            v-model="auditSettingData.isMultiple"
            :label="2"
            >否</el-radio
          >
        </el-form-item>
        <el-form-item
          label="评审模式"
          :disabled="auditSettingData.id || auditSettingData.id == 0"
          v-show="auditSettingData.isMultiple == 1"
        >
          <el-radio
            :disabled="auditSettingData.id || auditSettingData.id == 0"
            v-model="auditSettingData.reviewMode"
            :label="1"
            >平均分模式</el-radio
          ><el-radio
            :disabled="auditSettingData.id || auditSettingData.id == 0"
            v-model="auditSettingData.reviewMode"
            :label="2"
            >组长模式</el-radio
          >
        </el-form-item>
        <el-form-item
          label="论文可评审次数"
          :disabled="auditSettingData.id || auditSettingData.id == 0"
          v-show="auditSettingData.isMultiple == 1"
        >
          <el-input
            v-model="auditSettingData.reviewNum"
            :disabled="auditSettingData.id || auditSettingData.id == 0"
            style="width: 300px"
          ></el-input>
        </el-form-item>
        <el-form-item label="抽题数量">
          <el-input
            v-model="auditSettingData.distributionNum"
            :disabled="auditSettingData.id || auditSettingData.id == 0"
            style="width: 300px"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="auditSettingData.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="saveSettings">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="论文分配"
      :visible.sync="allocateThesisData.ifShow"
      width="700px"
      :append-to-body="true"
    >
      <el-form label-width="200px" :model="allocateThesisData">
        <el-form-item label="分配数量">
          <el-input
            disabled
            :value="
              allocateThesisData.ifAll
                ? searchCondition.total
                : selectIds.length
            "
          ></el-input>
        </el-form-item>
        <el-form-item label="论文分组" prop="reviewGroupId">
          <el-select
            v-model="allocateThesisData.reviewGroupId"
            size="small"
            placeholder="选择论文分组"
          >
            <el-option
              v-for="item in thesisGroupList"
              :key="item.id"
              :label="item.reviewGroupName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="allocateThesisData.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="allocateThesisSubmit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getPaperReviewList,
  reviewBatchPaper,
  paperReviewExcelImport,
  paperReviewExcelExport,
  oneClickRelease,
  oneClickSplit,
  getPaperApplyList,
  batchDownloadThesis,
  batchDownloadReport,
  saveReviewSettings,
  getReviewSettings,
  v1thesisGrouping,
  getThesisGroupList,
} from "@/api/paper.js";
import FileSave from "file-saver";
import Cookies from "js-cookie";
import pdfPreview from "@/views/my-components/other/pdf/pdfPreview.vue";

export default {
  data() {
    return {
      pdfData: {
        pdfUrl: null,
        pdfIfShow: false,
        currentPage: 1,
        totalPage: 0,
        pdfStream: null,
      },
      auditSettingData: {
        examinationId: null,
        ifShow: false,
        isMultiple: null,
        reviewNum: null,
        distributionNum: null,
        id: 0,
        reviewMode: 1,
      },
      roleCode: JSON.parse(Cookies.get("userInfo")).roles[0].code,
      downloadUrl: "../审核状态导入模板.xlsx",
      dialogVisible: false,
      fileList: [],
      searchCondition: {
        searchRangeTime: "",
        pageSize: 100,
        jumpPage: 1,
        paperGroupName: "",
        reviewStatus: "",
        createTime: "",
        auditTeacher: "",
        paperName: "",
        startTime: "",
        endTime: "",
        ids: [],
        total: 0,
        mobile: "",
        idCard: "",
        userName: "",
        distributeStatus: "",
      },
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
          key: "choose",
        },
        {
          title: "考试名称",
          key: "testName",
          width: 200,
        },
        {
          title: "分组名称",
          key: "reviewGroupName",
          width: 160,
        },
        {
          title: "是否分配",
          key: "distributeStatusText",
          width: 160,
        },
        {
          title: "论文名称",
          key: "paperName",
          width: 200,
        },
        {
          title: "得分",
          key: "avgScore",
          width: 80,
        },
        {
          title: "提交人",
          key: "userName",
          width: 100,
        },
        {
          title: "手机号",
          key: "mobile",
          width: 100,
        },
        {
          title: "身份证",
          key: "idCard",
          width: 200,
        },
        {
          title: "开题报告",
          key: "reportName",
          width: 200,
        },
        {
          title: "提交次数",
          key: "submitNum",
          width: 70,
        },
        {
          title: "审核状态",
          key: "reviewStatus",
          width: 90,
        },
        {
          title: "审核人员",
          key: "auditTeacher",
          width: 80,
        },
        {
          title: "提交时间",
          key: "createTime",
          width: 140,
        },
        {
          title: "操作",
          slot: "action",
          width: 180,
          align: "center",
        },
      ],
      paperReviewList: [],
      reviewOptions: [
        {
          value: 0,
          label: "审核不通过",
        },
        {
          value: 1,
          label: "审核通过",
        },
        {
          value: 2,
          label: "待审核",
        },
        {
          value: 3,
          label: "查重不合格",
        },
        {
          value: 4,
          label: "待查重",
        },
      ],
      selectIds: [],
      selectColumns: [],
      testList: [],
      thesisGroupList: [],
      allocateThesisData: {
        ifShow: false,
        ifAll: false,
        num: 0,
        reviewGroupId: null,
      },
    };
  },

  components: { pdfPreview },
  created() {},
  mounted() {
    if (this.roleCode == "bus") {
      this.columns.splice(
        this.columns.findIndex((item) => item.title == "手机号"),
        1
      );
      this.columns.splice(
        this.columns.findIndex((item) => item.title == "审核人员"),
        1
      );
    }
    getPaperApplyList({ source: 0 }).then((data) => {
      this.testList = data;
    });
    this.getPaperReviewList();

    this.pageInit();
  },
  methods: {
    allocateThesisSubmit() {
      if (this.allocateThesisData.reviewGroupId) {
        this.$confirm(
          `本次操作将分配${
            this.allocateThesisData.ifAll
              ? this.searchCondition.total
              : this.selectIds.length
          }次记录`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          let postData = this.allocateThesisData.ifAll
            ? this.searchCondition
            : { ids: this.selectIds };
          postData.reviewGroupId = this.allocateThesisData.reviewGroupId;
          v1thesisGrouping(postData)
            .then(() => {
              this.$message.success("一键分配成功");
              this.getPaperReviewList();
              this.allocateThesisData.ifShow = false;
            })
            .catch((err) => {
              this.error(data.message);
            });
        });
      } else {
        this.$message.warning("请选择论文分组");
      }
    },
    allocateThesis(ifAll) {
      switch (true) {
        case !ifAll && this.selectIds.length == 0:
          this.$alert("请勾选条目");
          return;
          break;
        case !ifAll &&
          this.selectColumns.some((column) => column.distributeStatus == 1):
          this.$alert("已分配的论文不可再分配");
          return;
          break;
        case ifAll && this.searchCondition.distributeStatus != 2:
          this.$alert("请设置分配状态为未分配");
          return;
          break;
        default:
          break;
      }

      this.allocateThesisData = {
        ifShow: true,
        ifAll: ifAll,
        reviewGroupId: null,
      };
    },
    saveSettings() {
      if (this.auditSettingData.id || this.auditSettingData.id == 0) {
        this.auditSettingData.ifShow = false;
      } else {
        if (
          (this.auditSettingData.isMultiple == 2 &&
            this.auditSettingData.distributionNum) ||
          (this.auditSettingData.isMultiple == 1 &&
            this.auditSettingData.distributionNum &&
            this.auditSettingData.reviewNum)
        ) {
          saveReviewSettings(this.auditSettingData).then((data) => {
            this.auditSettingData.ifShow = false;
            this.$message.success("设置成功");
          });
        } else {
          this.$alert("请输入必填项");
        }
      }
    },

    getReviewSettings() {
      getReviewSettings({
        examinationId: this.auditSettingData.examinationId,
      }).then((data) => {
        delete data.examinationId;
        Object.assign(this.auditSettingData, data);
      });
    },
    downloadReport(ifAll) {
      let postData = {};
      if (ifAll) {
        Object.assign(postData, this.searchCondition);
        delete postData.ids;
      } else {
        postData = { ids: this.selectIds };
      }
      //批量下载
      batchDownloadReport(postData).then((data) => {
        let itemFiltered = data.filter((item) => item);
        itemFiltered.forEach((item) => {
          console.log(item.openQuestionReport);
          const response = {
            "content-disposition": `attachment; filename=${encodeURIComponent(
              item.reportName +
                "." +
                item.openQuestionReport.split(".")[
                  item.openQuestionReport.split(".").length - 1
                ]
            )}`,
          };
          // object-key表示从OSS下载文件时需要指定包含文件后缀在内的完整路径，例如abc/efg/123.jpg。
          const url = this.$oss.signatureUrl(
            decodeURI(item.openQuestionReport)
              .trim()
              .replace("https://cbsystem.oss-cn-shenzhen.aliyuncs.com/", ""),
            { response }
          );
          window.open(url);
        });
      });
    },
    timeRangeChange(value) {
      if (value) {
        [this.searchCondition.startTime, this.searchCondition.endTime] = value;
      } else {
        [this.searchCondition.startTime, this.searchCondition.endTime] = [
          "",
          "",
        ];
      }
    },
    resetSearchCondition() {
      Object.assign(this.searchCondition, this.$options.data().searchCondition);
    },
    pdfShow(row) {
      // var loadingTask = pdf.createLoadingTask(row.paperUrl);
      this.pdfData.pdfUrl = row.paperUrl;
      this.pdfData.pdfIfShow = true;
      // this.pdfData.pdfStream = loadingTask;
      // console.log(loadingTask);
    },

    goToDetail(routerName, item, e) {
      this.$router.push({
        name: routerName,
        query: { id: item.id, userId: item.userId, type: e },
      });
    },
    download(url) {
      var oReq = new XMLHttpRequest();
      oReq.open("GET", url, true);
      oReq.responseType = "blob";
      oReq.onload = function () {
        var file = new Blob([oReq.response], {
          type: "application/pdf",
        });
        // , `${row.userName}-${row.testName}-${row.id}.pdf`
        FileSave.saveAs(
          file,
          decodeURI(url.split("/")[url.split("/").length - 1])
        );
      };
      oReq.send();
    },
    getPaperReviewList() {
      console.log("筛选条件searchCondition=", this.searchCondition);
      getPaperReviewList(this.searchCondition).then((data) => {
        console.log("paperSettingList结果", data);
        this.paperReviewList = data.records;
        this.searchCondition.total = data.total;
        this.selectIds = [];
      });
    },

    choosenChange(selection) {
      this.selectIds = selection.map((item) => item.id);
      this.selectColumns = selection;
    },

    reviewBatchPaper(e) {
      this.$Modal.confirm({
        title: "批量审核",
        content: "<p>正在进行批量审核,请您谨慎操作</p>",
        onOk: () => {
          reviewBatchPaper({
            ids: this.selectIds,
            reviewStatus: e,
          }).then((data) => {
            this.$Message.success("批量操作成功");
            this.getPaperReviewList();
          });
        },
        onCancel: () => {
          this.$Message.info("批量操作已取消");
        },
      });
    },

    exportData() {
      paperReviewExcelExport(this.searchCondition)
        .then((data) => {
          this.$message.success("上传成功!");
          const pdfUrl = window.URL.createObjectURL(
            new Blob([data], {
              type: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`,
            })
          );
          const link = document.createElement("a");
          link.href = pdfUrl;
          link.setAttribute("download", "论文查重审核列表.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    uploadPaper(e) {
      let formData = new FormData();
      formData.append("file", e.file);
      paperReviewExcelImport(formData)
        .then((data) => {
          console.log("来咯", data);
          this.$message.success("上传成功!");
          const pdfUrl = window.URL.createObjectURL(
            new Blob([data], {
              type: `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet`,
            })
          );
          const link = document.createElement("a");
          link.href = pdfUrl;
          link.setAttribute("download", "更新查重状态失败列表.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .catch((err) => {
          console.error(err);
        });
    },

    importData() {
      if (this.$refs.upload) {
        this.$refs.upload.submit();
        this.dialogVisible = false;
      } else {
        console.error("未找到upload控件");
      }
    },

    //重置 upload文件
    reset() {
      this.$refs.upload = null;
    },

    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$notify.error({
        title: "错误",
        message: "只能上传一个文件哦",
      });
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {
      console.log("file00000", file);
      if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
        this.$notify.error({
          title: "错误",
          message: "上传文件只能为excel文件，且为xlsx,xls格式",
        });
        this.fileList = [];
        this.file = "";
        return false;
      }
      this.file = file.raw;
      this.filename = file.name;
    },

    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile(file) {
      console.log("before upload");
      console.log(file);
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      let size = file.size / 1024 / 1024;
      if (extension !== "xlsx") {
        this.$notify.warning({
          title: "警告",
          message: `只能上传后缀是(.xlsx或者.xls）的文件`,
        });
      }
      if (size > 10) {
        this.$notify.warning({
          title: "警告",
          message: `文件大小不得超过10M`,
        });
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(res, file, fileList) {
      let blob = new Blob([JSON.stringify(res)], { type: "application/json" });
      // console.log('blob', blob)
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.download = "change_" + file.name;
      a.click();
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: "错误",
        message: `文件上传失败`,
      });
    },

    oneClickRelease(ifAll) {
      console.log(this.selectIds);

      this.$confirm(
        `本次操作将发布${
          ifAll ? this.searchCondition.total : this.selectIds.length
        }次记录`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        let postData = ifAll ? this.searchCondition : { ids: this.selectIds };
        oneClickRelease(postData)
          .then(() => {
            this.$message.success("一键发布成功");
            this.getPaperReviewList();
          })
          .catch((err) => {
            this.error(data.message);
          });
      });
    },
    batchDownloadThesis(ifAll) {
      this.$confirm(
        `本次操作将下载${
          ifAll ? this.searchCondition.total : this.selectIds.length
        }篇论文`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        let postData = ifAll ? this.searchCondition : { ids: this.selectIds };
        batchDownloadThesis(postData)
          .then((data) => {
            data.forEach((item) => {
              this.download(item.paperUrl);
            });

            console.log(data);
            // this.$message.success("一键下载成功");
            // this.getPaperReviewList();
          })
          .catch((err) => {
            this.error(data.message);
          });
      });
    },
    oneClickSplit(ifAll) {
      this.$confirm(
        `本次操作将分配${
          ifAll ? this.searchCondition.total : this.selectIds.length
        }次记录`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        let postData = ifAll ? this.searchCondition : { ids: this.selectIds };
        oneClickSplit(postData)
          .then(() => {
            this.$message.success("一键分配成功");
            this.getPaperReviewList();
          })
          .catch((err) => {
            this.error(data.message);
          });
      });
    },
    pageInit() {
      getThesisGroupList({ pageSize: 1000, jumpPage: 1 }).then((data) => {
        this.thesisGroupList = data.records;
        console.log(this.thesisGroupList);
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  font-size: 12px;

  .contentBox {
    padding: 20px;

    .searchBar {
      background: #fff;
      padding: 20px;
      margin-bottom: 15px;
    }

    //.lineStyle {
    //  overflow: scroll;
    //  width: 100%;
    //}

    .tableContainer {
      background: #fff;
      padding: 20px;

      .actionBar {
        padding-bottom: 10px;

        .reviewBar {
          float: right;
          margin-left: 10px;
        }
      }

      .bluBar {
        width: auto;
        color: #36aafd;
        border: 1px solid #36aafd;
        padding: 7px 10px;
        border-radius: 4px !important;
      }
    }
  }
}
.el-dropdown-menu__item {
  text-align: center;
}
/deep/ .ivu-table-cell {
  padding: 0 10px;
}
</style>
